import FormattedRecordTimestamp from './FormattedRecordTimestamp';

const TableFormattedTimestamp = ({
                                     record,
                                     propertyName
                                 }: { record: { [key: string]: any }, propertyName: string }) => {

    const formatOptions = {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    } as Intl.DateTimeFormatOptions;

    return (
        <FormattedRecordTimestamp record={record} propertyName={propertyName} formatOptions={formatOptions}/>
    );

};

export default TableFormattedTimestamp;
